import { Image } from '@chakra-ui/react';
import React, { useState } from 'react';

import mainLogo from 'packages/common-frontend/images/Logo-Horizontal-Normal.svg';
import { LoggedOutContainer } from 'packages/logged-out/ui/LoggedOutContainer';
import { useSideBarContext } from 'packages/sidebar/hooks/sideBarContext';

export const HomeRoute = () => {
  const { setSideBarOpen } = useSideBarContext();

  const [logoLoaded, setLogoLoaded] = useState(false);

  return (
    <>
      <LoggedOutContainer
        onSubmit={() => setSideBarOpen(false)}
        logoImage={
          <Image
            src={mainLogo}
            alt="Logo"
            width="185px"
            display={logoLoaded ? 'block' : 'none'}
            height="100%"
            onLoad={() => {
              setLogoLoaded(true);
            }}
          />
        }
      />
    </>
  );
};
